<div id="userCard" [ngClass]="{selected: selected}" class="flexRowContainer">
  <span id="userIcon" class="title-medium">
    {{ getUserInitials(user) }}
  </span>
  <div id="userInfo" class="flexColumnContainer">
    <span id="name" class="body-large">
      <span>{{ user?.firstName }} {{ user?.lastName }}</span>
      @if (user?.additionalInfo) {
        <app-additional-user-info id="additionalInfo" class="body-small"
                                  [text]="user?.additionalInfo"></app-additional-user-info>
      }
    </span>
    @if (user?.email?.trim()) {
      <span id="email" class="body-medium">{{ user?.email }}</span>
    } @else {
      <span id="emailMissing" class="body-medium">{{ 'userSelection.userCard.noEmail' | translate }}</span>
    }
  </div>
  @if (selected) {
    <button id="deselectUserButton" mat-icon-button (click)="deselectUser()"
            aria-label="Deselect User">
      <mat-icon class="material-icons-outlined">cancel</mat-icon>
    </button>
  }
</div>
